/**
 * Escala de color para consignas / temperaturas de schedule (°C).
 * - < 16 → azul
 * - 16–<19 → verde
 * - 19–<22 → naranja claro
 * - 22–<25 → naranja oscuro
 * - ≥ 25 → rojo (naranja muy oscuro / rojo)
 */
export function evohomeTempColor(tempC: number | null | undefined): string {
  const t = Number(tempC);
  if (!Number.isFinite(t)) return '#FF8A65';
  if (t < 16) return '#42A5F5';
  if (t < 19) return '#66BB6A';
  if (t < 22) return '#FFB74D';
  if (t < 25) return '#FF8A65';
  return '#EF5350';
}
